import { createRoot } from "react-dom/client";
import styles from "./UnderageVerify.module.less";
import { useEffect, useState } from "react";
import { Toast } from "react-vant";

const numbersMap = {
  1: "壹",
  2: "贰",
  3: "叁",
  4: "肆",
  5: "伍",
  6: "陆",
  7: "柒",
  8: "捌",
  9: "玖",
};
export const showVerifyModal = (callback) => {
  const modalId = "modal-share-container-verify";

  const existingModal = document.getElementById(modalId);
  if (existingModal) {
    try {
      document.body.removeChild(existingModal);
    } catch (error) {
      console.warn("Failed to remove existing modal:", error);
    }
  }

  const modalDiv = document.createElement("div");
  modalDiv.id = modalId;
  document.body.appendChild(modalDiv);
  const root = createRoot(modalDiv);

  const destroyModal = () => {
    try {
      root.unmount();
    } catch (error) {
      console.warn("Failed to unmount root:", error);
    }

    try {
      if (document.body.contains(modalDiv)) {
        document.body.removeChild(modalDiv);
      }
    } catch (error) {
      console.warn("Failed to remove modal div:", error);
    }
  };

  const handleMaskClick = (e) => {
    if (e.target === e.currentTarget) {
      destroyModal();
    }
  };

  const Modal = () => {
    const [activeList, setActiveList] = useState([]);
    const [numbersList, setNumbersList] = useState([]);

    const handleClickNumber = (number) => {
      setActiveList((prev) => {
        if (prev.length >= 3) {
          return prev;
        }
        return [...prev, number];
      });
    };

    useEffect(() => {
      const allNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];

      for (let i = allNumbers.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [allNumbers[i], allNumbers[j]] = [allNumbers[j], allNumbers[i]];
      }

      setNumbersList(allNumbers.slice(0, 3));
    }, []);

    useEffect(() => {
      if (activeList.length >= 3) {
        const target = numbersList.slice(0, 3);
        const selected = activeList.slice(0, 3);

        const isMatch = target.every((num, index) => num === selected[index]);

        if (isMatch) {
          setTimeout(() => {
            callback && callback();
            destroyModal();
          }, 100);
        } else {
          Toast.info("验证失败，请重新输入");
          setActiveList([]);
        }
      }
    }, [activeList]);
    return (
      <div className={styles.modalOverlay} onClick={handleMaskClick}>
        <div className={styles["verify-box"]}>
          <div className={styles["text-list"]}>
            {numbersList.map((item, index) => (
              <div className={styles["text-list-item"]} key={index}>
                {numbersMap[item]}
              </div>
            ))}
          </div>
          <div className={styles["active-list"]}>
            {Array.from({ length: 3 }, (_, index) => (
              <img
                className={styles["active-list-item"]}
                key={index}
                src={
                  activeList.length > index
                    ? require(
                        `@/images/picture/underage-verify/icon_active.png`
                      )
                    : require(
                        `@/images/picture/underage-verify/icon_disabled.png`
                      )
                }
              />
            ))}
          </div>
          <div className={styles["numbers-list"]}>
            {Array.from({ length: 9 }, (_, index) => (
              <img
                className={styles["numbers-list-item"]}
                key={index}
                src={require(
                  `@/images/picture/underage-verify/button_${index + 1}.png`
                )}
                onClick={() => handleClickNumber(index + 1)}
              />
            ))}
          </div>
        </div>
        <img
          className={styles["close-button"]}
          src={require("@/images/picture/underage-verify/close.png")}
          onClick={destroyModal}
        />
      </div>
    );
  };

  root.render(<Modal />);
  return destroyModal;
};
